import { NgModule, Type } from '@angular/core';
import { NkDateTimeEditModule } from '../datetime-edit/datetime-edit.module';
import { NkRangeDateTimeEdit } from './range-datetime-edit';

const NK_DIRECTIVES: Type<any>[] = [NkRangeDateTimeEdit];
const modules: Type<any>[] = [NkDateTimeEditModule];

@NgModule({
  imports: [...modules],
  declarations: [...NK_DIRECTIVES],
  exports: [...NK_DIRECTIVES, ...modules]
})
export class NkRangeDateTimeEditModule {}
